<a id="patient-logo" class="navbar-brand" (click)="goHome() ">
  <img [src]="currentAgency && currentAgency.logoUrl ? currentAgency.logoUrl :
             'https://www.celerityllc.net/images/celerity-logo.png'" height="30" [alt]="currentAgency?.name"/>
</a>
<button class="navbar-toggler celerity-local-navbar-toggler" type="button" aria-label="Toggle navigation"
  (click)="toggleCollapsed()">
  <span class="navbar-toggler-icon"></span>
</button>

<div class="collapse navbar-collapse justify-content-end">
  <ul class="navbar-nav">
    <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-right">
      <a class="nav-link celerity-local-profile-dropdown" ngbDropdownToggle id="navbar-dropdown" role="button">
        <span>{{currentPatient?.firstName}} {{currentPatient?.lastName}}</span>
        <fa-icon [icon]="faUserCircle"></fa-icon>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbar-dropdown" class="dropdown-menu">
        <a ngbDropdownItem (click)="signOut()">Sign out</a>
        <a ngbDropdownItem (click)="backToAdmin()" *ngIf="adminActingAsPatient">Back to Admin Site</a>
      </div>
    </li>
  </ul>
</div>

<div class="collapse navbar-collapse" [class.collapse]="isNavbarCollapsed" *ngIf="!isNavbarCollapsed"
  id="navbarContent">
  <ng-content></ng-content>
  <ul class="celerity-nav-container navbar-nav list-group list-group-flush">
    <li class="list-group-item celerity-nav-item" ngbDropdown display="dynamic" placement="bottom-right">
      <a class="nav-link" role="button" (click)="signOut()">
        <div class="celerity-local-sign-out-link">
          <div class="d-flex align-items-center justify-content-between">
            <fa-icon [icon]="faUserCircle"></fa-icon>
            <p>{{currentPatient?.firstName}} {{currentPatient?.lastName}}</p>
          </div>
          <div>Sign out</div>
        </div>
      </a>
    </li>
    <li *ngIf="adminActingAsPatient" class="list-group-item celerity-nav-item" ngbDropdown display="dynamic" placement="bottom-right">
      <a class="nav-link" role="button" (click)="backToAdmin()">
        <div class="celerity-local-sign-out-link">
          <div class="d-flex align-items-center justify-content-between">
            <fa-icon [icon]="faUserCircle"></fa-icon>
            <p>{{currentPatient?.firstName}} {{currentPatient?.lastName}}</p>
          </div>
          <div>Back to Admin Site</div>
        </div>
      </a>
    </li>
  </ul>
</div>
